import { EnumTranslationService } from './../../services/enum-translation.service';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, forwardRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IdProvider } from '../id-provider';

@Component({
    selector: 'app-button-group',
    templateUrl: './button-group.component.html',
    styleUrls: ['./button-group.component.scss'],
    imports: [ReactiveFormsModule, NgClass, TranslateModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ButtonGroupComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ButtonGroupComponent),
            multi: true
        }
    ]
})
export class ButtonGroupComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @Input() public fieldsEnum: any;
  @Input() public translateKey = '';
  @Input() public additionalCss: string = '';
  @Input() public isNumericEnum = false;

  @Input() public set hide(value: any[]) {
    this._hide = value ?? [];
    if (this.isInitialized) {
      this.keyList = this.getKeys();
    }
  }

  public get hide(): any[] {
    return this._hide;
  }

  public id: string = IdProvider.getNextId();
  public form: UntypedFormGroup;
  public keyList: any[];
  public onChange: any = () => { };
  public onTouched: any = () => { };
  public disabled: boolean;

  private subscriptions: Subscription[] = [];
  private _hide: any[] = [];
  private isInitialized = false;

  constructor(private formBuilder: UntypedFormBuilder,
    private enumTranslationService: EnumTranslationService) {
    this.form = this.formBuilder.group({
      formValue: ''
    });

    this.subscriptions.push(
      // any time the inner form changes update the parent of any change
      this.form.valueChanges.subscribe(value => {
        this.onChange(value?.formValue);
        this.onTouched();
      })
    );
  }

  public get class(): string {
    return "e-btn " + this.additionalCss;
  }

  ngOnInit() {
    this.keyList = this.getKeys();
    this.isInitialized = true;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private getKeys(): any[] {
    return this.enumTranslationService.convertToTranslationStrings(this.fieldsEnum, this.translateKey, this.isNumericEnum)
      .filter(item => !this.hide.some(e => e === item.key));
  }

  writeValue(value: any): void {
    this.form.controls.formValue.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (this.disabled) {
      this.form.controls.formValue.disable();
    } else {
      this.form.controls.formValue.enable();
    }
  }

  validate(_: UntypedFormControl) {
    return null;
  }
}
